export const tuple = <T extends string[]>(...args: T) => args;

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

/**
 * 表示组件支持通过 className 和 style 进行样式定制
 */
export interface StyledProps {
  className?: string;
  style?: React.CSSProperties;
}
